<template>
  <div id="playercontent">
    <div ref="dplayer" id="dplayer" @dblclick="fullScreen"></div>
    <classTest
      :showTest="showTest"
      :videoCurrentTime="videoCurrentTime"
      :duration="duration"
      ref="classTest"
    >
    </classTest>
  </div>
</template>

<script>
import Hls from "hls.js";
import DPlayer from "dplayer";
import classTest from "@/views/homepage/course/class-test.vue";
export default {
  components: {
    classTest,
  },
  props: {
    showTest: {
      type: Boolean,
      default: false,
    },
    options: Object,
    pointData: "",
    nextTime: 0,
    videoStatus: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      qulity: [], //清晰度
      videoCurrentTime: "", //当前播放时间
      duration: "", //总时间
      allTestTime: [], //所有测试点
      needScore: false, //分数
      cutid: this.$route.query.cutid, //切片id
      isFullScreen: false, //是否全屏
      videoType: "auto", //视频类型
      loop: true, //循环播放
      isPause: Boolean, //当前是否暂停
      observer: null, //监测dom的实例
      defaultQuality: 0, //默认清晰度
      timer: null, // 检测用户观看记录
    };
  },
  watch: {
    videoCurrentTime: {
      handler(a, b) {
        if (this.duration === parseInt(a) && parseInt(a) !== parseInt(b)) {
          let obj = { complete_status: 1, videoTime: parseInt(a) };
          this.$emit("postViewTime", obj);
          this.$emit("goTest");
        }
      },
      deep: true,
    },
    isPause(nv, ov) {
      if (nv == false) {
        this.$emit("getVideoCountTime");
      } else {
        this.$emit("notCountTime");
      }
    },
    videoStatus: {
      handler(a, b) {
        if (!a) {
          this.handDisplayNone(a);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initDPlayer();
      this.startVideo();
      // this.player.play();
      this.getConfig();

      this.handleDisplayMenu();

      this.setSwitchQuality();
    });
  },
  beforeDestroy() {
    this.$emit("notCountTime");
    if (this.observer) {
      this.observer.disconnect();
    }
    this.player?.destroy();
  },
  methods: {
    handDisplayNone(status) {
      //status 获取视频是否观看完成
      let speed = document.querySelector(
        "#dplayer .dplayer-controller .dplayer-bar-wrap"
      );
      if (!speed) {
        return;
      }
      if (!status) {
        speed.style.display = "none";
      } else {
        speed.style.display = "block";
      }
    },

    handleDisplayMenu() {
      document.querySelector("#dplayer").oncontextmenu = () => {
        document.querySelector(".dplayer-menu").style.display = "none";
        document.querySelector(".dplayer-mask").style.display = "none";
        return false;
      };
    },
    countTime() {
      this.timer = setInterval(() => {
        // 2023-4-14 后端说这两个要改成同时进行
        // if (sessionStorage.getItem("tencentCloud") == 0) {
        this.getVideoCountTime(); // 会议版——十秒统计一次观看时长
        // } else {
        this.getVideoView(); //商学院统计观看记录方法
        // }
      }, 10000);
    },
    notCountTime() {
      clearInterval(this.timer);
    },
    getVideoCountTime() {
      let params = this.countTimeForm;
      let success = (res) => {
        // console.log(res, this.countTimeForm,'提交观看时间')
        // this.view = !(res.data.status === false);
      };
      this.$ajax.post("api/video/video_views_count", params, {
        func: { success },
      });
    },

    //商学院观看记录，
    getVideoView() {
      let params = this.countTimeForm;
      let success = (res) => {
        // console.log('提交观看记录', res)
        // this.view = !(res.data.status === false);
      };
      this.$ajax.post("api/video/video_views_company", params, {
        func: { success },
      });
    },
    // 获取全局防盗录配置
    getConfig() {
      let success = (res) => {
        // console.log('视频配置',this.options.safe_status, '全局配置', res.data.safe_show)
        if (res.data.safe_show === 1) {
          // 如果全局防盗录配置和单个视频防盗录配置同时打开，那么则开启跑马灯
          this.ipRuning();
        } else {
          // 否则不开启
          return;
        }
      };
      this.$ajax("/api/video/live_app_show", {
        params: { type: 3 },
        func: { success },
      });
    },
    domObserver(targetNode) {
      const config = {
        childList: true,
        attributes: true,
        subtree: true,
      };
      const callback = (mutationsList, observer) => {
        for (let mutation of mutationsList) {
          let remove = mutation.removedNodes[0];
          if (
            mutation.type === "childList" &&
            remove &&
            remove.className === "ipRuning"
          ) {
            let isExit =
              document.getElementById("dplayer").childNodes[0].className ===
              "ipRuning";
            if (!isExit) {
              this.ipRuning("observer");
            }
            // 使用nextTick函数是防止生成新的定时器时，还没有清除上次的定时器，
          }
        }
      };
      this.observer = new MutationObserver(callback);
      this.observer?.observe(targetNode, config);
    },
    // 获取指定范围内随机数的函数
    getRandomIntInclusive(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
    },
    ipRuning(isObserve) {
      // 用来生成水印dom的函数
      // 如果携带参数，则说明需要生成dom，但不需要生成观测器
      let top = this.getRandomIntInclusive(5, 96);
      let divText =
        "当前用户：" +
        JSON.parse(sessionStorage.getItem("user_info_str")).id +
        "，" +
        JSON.parse(sessionStorage.getItem("user_info_str")).name;
      let aDOM = document.getElementById("dplayer");

      let newDiv = document.createElement("div");
      newDiv.innerHTML = divText;
      newDiv.className = "ipRuning";
      newDiv.style.top = top + "%";
      aDOM.insertBefore(newDiv, aDOM.firstChild);
      if (!isObserve) this.domObserver(aDOM);

      setTimeout(() => {
        newDiv.remove();
      }, 15000);
    },
    initDPlayer() {
      this.qulity = [];
      this.getVideoType();
      this.showQuality();
      const hls = new Hls();
      console.log("videoStatus----", this.videoStatus);
      const dp = {
        container: this.$refs["dplayer"],
        // 播放器的一些参数
        // contextmenu: [''],                                                  //右键菜单
        autoplay: true, //视频自动播放
        theme: "#FADFA3", //主题色
        loop: false, //视频循环播放
        lang: "zh-cn", //语言
        live: false,
        screenshot: true, //开启截图，如果开启，视频和视频封面需要允许跨域
        // videoStatus 1 可拖动进度条 0 禁止拖动
        hotkey: this.videoStatus ? true : false, //开启热键，支持快进、快退、音量控制、播放暂停
        preload: "auto", //视频预加载，可选值: 'none', 'metadata', 'auto'
        // logo: require('logo.png'),                                     //左上角logo
        volume: 0.7, //默认音量，请注意播放器会记忆用户设置，用户手动设置音量后默认音量即失效
        mutex: true, //互斥，阻止多个播放器同时播放，当前播放器播放时暂停其他播放器
        playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2], //可选的播放速率，可以设置成自定义的数组
        video: {
          //视频信息
          url: this.options.pc_play_url, //视频链接
          pic: this.BASE_URL + this.options.thumbnail_picture,
          type: this.videoType, //可选值: 'auto', 'hls', 'flv', 'dash', 'webtorrent', 'normal' 或其他自定义类型, 见#MSE 支持
          // customType: {
          //   customHls: function (video, player) {
          //     hls.loadSource(video.src);
          //     hls.attachMedia(video);
          //   },
          // },
          // 仅为非Safari浏览器添加customHls处理
          customType: /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
            ? {}
            : {
                customHls: function (video, player) {
                  const hls = new Hls();
                  hls.loadSource(video.src);
                  hls.attachMedia(video);
                },
              },
          danmaku: false,
          // thumbnails: 'thumbnails.jpg',                                //视频缩略图，可以使用 DPlayer-thumbnails (opens new window)生成
          quality: this.qulity,
          defaultQuality: this.defaultQuality,
        },
        highlight: this.pointData, //高亮点（打点功能）
      };
      const player = new DPlayer(dp);
      this.player = player;
      this.handDisplayNone(this.videoStatus);
      this.getVideoTest(player);
      // this.countTime(this.player);
      player.on("ended", this.handlePlayEnd);
      player.on("pause", this.handlePause);
      player.on("play", this.handlePlay);
      player.on("canplaythrough", (e) => {
        this.player?.play();
      });
    },
    handlePause() {
      this.$emit("pause");
    },

    handlePlay() {
      this.$emit("play");
    },
    setSwitchQuality() {
      this.$refs["dplayer"].addEventListener("click", async (e) => {
        let old = this.defaultQuality;
        if (e.target.classList.contains("dplayer-quality-item")) {
          if (old === +e?.target?.dataset?.index ?? 1) {
            return;
          }
          this.player && this.player.destroy();
          this.defaultQuality = +e?.target?.dataset?.index ?? 1;
          this.initDPlayer();
          this.startVideo(this.videoCurrentTime);
        }
      });
    },
    handlePlayEnd() {
      this.$emit("end");
    },

    showQuality() {
      let qualityAll = [
        //清晰度
        {
          name: "480P",
          url: this.options["480P"],
          type: this.videoType,
        },
        {
          name: "720P",
          url: this.options["720P"],
          type: this.videoType,
        },
        {
          name: "1080P",
          url: this.options["1080P"],
          type: this.videoType,
        },
        {
          name: "原视频",
          url: this.options.pc_play_url,
          type: this.videoType,
        },
      ];
      if (this.options["1080P"]) {
        this.qulity.push(qualityAll[2]);
      }
      if (this.options["720P"]) {
        this.qulity.push(qualityAll[1]);
      }
      if (this.options["480P"]) {
        this.qulity.push(qualityAll[0]);
      }
      if (this.qulity.length == 0) {
        this.qulity.push(qualityAll[3]);
      }
    },
    getVideoTest(player) {
      //测试点时弹出classTest
      this.allTestTime = this.$refs.classTest.allTestTime;
      let shakingFlag = 0;
      this.player.on("timeupdate", () => {
        this.videoCurrentTime = player.video.currentTime;
        if (!this.duration) {
          this.duration = parseInt(player.video.duration);
        }

        let videoCurrentTime = parseInt(this.videoCurrentTime);

        // console.info(this.$refs.classTest.allTestTime, videoCurrentTime, '-------------------')

        // 播放到测试时间节点，获取测试题目进行展示
        if (this.allTestTime.includes(videoCurrentTime)) {
          if (this.showTest) this.$refs.classTest.dplayerTest(videoCurrentTime);
          this.allTestTime = this.$refs.classTest.allTestTime;
        }
        this.$emit("update:videoCurrentTime", videoCurrentTime);
        // console.log('当前播放时间点=====', videoCurrentTime, '+++++++', this.duration)
        if (this.duration && parseInt(this.duration) <= videoCurrentTime) {
          // 简单防抖
          if (shakingFlag === 0) {
            shakingFlag = 1;
            this.$refs.classTest.dplayerEnd();
          }
        }
      });
    },
    playVideo() {
      this.player.play();
    },
    pauseVideo() {
      this.player.pause();
    },
    startVideo(videoCurrentTime) {
      if (videoCurrentTime) {
        return this.player.seek(this.videoCurrentTime);
      }

      this.nextTime && this.player.seek(this.nextTime);
    },
    //全屏
    fullScreen() {
      if (this.isFullScreen) {
        this.player.fullScreen.cancel("browser");
        this.isFullScreen = false;
      } else {
        this.player.fullScreen.request("browser");
        this.isFullScreen = true;
      }
    },
    //判断播放类型
    getVideoType() {
      // let suffix = this.options["pc_play_url"].substring(
      //   this.options["pc_play_url"].lastIndexOf(".") + 1
      // );
      // if (suffix === "m3u8") {
      //   this.videoType = "customHls";
      // } else {
      //   this.videoType = "auto";
      // }
      let suffix = this.options["pc_play_url"].substring(
        this.options["pc_play_url"].lastIndexOf(".") + 1
      );

      // 检测是否为Safari浏览器
      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );

      if (suffix === "m3u8" && !isSafari) {
        this.videoType = "customHls";
      } else {
        this.videoType = "auto"; // Safari会自动使用原生HLS支持
      }
    },
    countTime(player) {
      player.video.ontimeupdate = () => {
        this.isPause = player.video.paused;
      };
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(#dplayer) {
  height: 100%;
  overflow: visible;
  margin: auto;

  .dplayer-video-current {
    /* width: auto; */
    height: 100%;
    /* width: 1200px; */
    margin: 0px auto;
  }

  .dplayer-video-wrap {
    height: 100%;
    overflow: hidden;
  }

  .dplayer-setting-loop {
    display: none;
  }

  .dplayer-setting-item {
    line-height: 18px;
  }
}

#playercontent {
  height: 100%;
  // width: 1200px;
}

:deep(.ipRuning) {
  white-space: nowrap;
  position: absolute;
  // top: 96;
  // left: 90%;
  z-index: 100;
  color: gray;
  font-size: 1.5rem;
  animation-name: runing;
  animation-duration: 15s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes runing {
  from {
    left: 0;
  }

  to {
    left: 100%;
  }
}
</style>